/// <reference types="vite/client" />

const modules = import.meta.glob('./*/*.ts', { eager: true });

type NamespaceResource = Record<string, unknown>;
type LocaleResources = Record<string, NamespaceResource>;
type Messages = Record<string, LocaleResources>;

const messages: Messages = {};

Object.entries(modules).forEach(([path, imported]) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (!match) {
    return;
  }

  const [, lang, namespace] = match;
  const module = imported as { default?: NamespaceResource };

  if (!messages[lang]) {
    messages[lang] = {};
  }

  if (!messages[lang][namespace]) {
    messages[lang][namespace] = {};
  }

  if (module.default) {
    messages[lang][namespace] = {
      ...messages[lang][namespace],
      ...module.default,
    };
  }
});

export default messages;

